import { FC } from "react";
import { DataGrid } from "../../../components/datagrid";
import { entityBasePath } from "../../../utils/entityPaths";
import {
  MergerRow,
  useActiveMergers,
  useCompletedMergers
} from "../dataHooks/mergerQueries";
import { useMergerColumns } from "./hooks/useMergerColumns";

const rowHref = (row: MergerRow) =>
  `${entityBasePath(row.kind, true)}/${row.id}`;

const gridSx = {
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none"
  }
};

export const MergersGrid: FC = () => {
  const { rows, loading } = useActiveMergers();
  const columns = useMergerColumns("active");

  return (
    <DataGrid
      loading={loading}
      columns={columns}
      rows={rows}
      getRowId={(row) => row.rowKey}
      getRowHref={(row) => rowHref(row as MergerRow)}
      searchPlaceholder="Search mergers"
      exportFileName="Mergers"
      initialState={{
        sorting: { sortModel: [{ field: "urgent", sort: "desc" }] }
      }}
      sx={gridSx}
    />
  );
};

export const CompletedMergersGrid: FC = () => {
  const { rows, loading } = useCompletedMergers();
  const columns = useMergerColumns("completed");

  return (
    <DataGrid
      loading={loading}
      columns={columns}
      rows={rows}
      getRowId={(row) => row.rowKey}
      getRowHref={(row) => rowHref(row as MergerRow)}
      searchPlaceholder="Search completed mergers"
      exportFileName="Completed mergers"
      initialState={{
        sorting: { sortModel: [{ field: "signOffCompletedAt", sort: "desc" }] }
      }}
      sx={gridSx}
    />
  );
};
